import {
  TesEmployeeDetailsGetters,
  TesEmployeeDetailsMutations,
  TesEmployeeDetailsActions
} from '@/app/features/tes-employees/features/tes-employee-details/tes-employee-details.keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import { tesEmployeeDetailsService } from '@/app/features/tes-employees/features/tes-employee-details/tes-employee-details.service';
import i18n from '@/i18n';
import router from '@/router';

export const getDefaultState = () => {
  return {
    isLoading: true,
    isOnScreenTesEmployeeModified: false,
    currentTesEmployee: {},
    tesEmployeesValidationErrors: {}
  };
};

export const tesEmployeeDetailsStore = {
  state: getDefaultState(),
  getters: {
    [TesEmployeeDetailsGetters.CurrentTesEmployee]: state => {
      return state.currentTesEmployee;
    },
    [TesEmployeeDetailsGetters.TesEmployeeValidationErrors]: state => {
      return state.tesEmployeesValidationErrors;
    }
  },

  mutations: {
    [TesEmployeeDetailsMutations.ResetTesEmployeeState]: function(state) {
      Object.assign(state, getDefaultState());
    },
    [TesEmployeeDetailsMutations.SetLoading]: (state, isLoading = true) => {
      state.isLoading = isLoading;
    },
    [TesEmployeeDetailsMutations.RetrieveTesEmployeeSuccess]: (state, tesEmployee) => {
      state.currentTesEmployee = tesEmployee;
      state.isOnScreenTesEmployeeModified = false;
    },
    [TesEmployeeDetailsMutations.SetTesEmployeeValidationErrors]: function(state, errors) {
      state.tesEmployeesValidationErrors = errors;
    }
  },

  actions: {
    [TesEmployeeDetailsActions.ResetCurrentTesEmployee]: function({ commit, dispatch }) {
      dispatch(TolErrorsActions.ClearAll);
      commit(TesEmployeeDetailsMutations.ResetTesEmployeeState);
    },
    [TesEmployeeDetailsActions.RetrieveTesEmployee]: ({ commit, dispatch }, reference_number) => {
      tesEmployeeDetailsService
        .retrieveTesEmployee(reference_number)
        .then(tesEmployee => {
          commit(TesEmployeeDetailsMutations.RetrieveTesEmployeeSuccess, tesEmployee);
        })
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
          commit(TesEmployeeDetailsMutations.SetLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('tesEmployees.details.errors.retrieveTesEmployee')
          });
          commit(TesEmployeeDetailsMutations.SetLoading, false);
        });
    },

    [TesEmployeeDetailsActions.SaveTesEmployee]: function({ dispatch }, params) {
      let { tesEmployeeData, action } = params;
      tesEmployeeDetailsService
        .saveTesEmployee(tesEmployeeData, action)
        .then(status => {
          if (status.message === 'success') {
            dispatch(TesEmployeeDetailsActions.RetrieveTesEmployee, status.data);

            dispatch(TesEmployeeDetailsActions.UpdateTesEmployeeValidationErrors);
            dispatch(TolMessagesActions.SetMessages, {
              text: i18n.t('tesEmployees.details.info.saveTesEmployee')
            });
            router.replace({ path: `/tes-employees/${status.data}` }).catch(() => {});
          } else {
            dispatch(TesEmployeeDetailsActions.UpdateTesEmployeeValidationErrors, status.errors);
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [TesEmployeeDetailsActions.UpdateTesEmployeeValidationErrors]: ({ commit }, errors = {}) => {
      commit(TesEmployeeDetailsMutations.SetTesEmployeeValidationErrors, errors);
    }
  }
};
